import React from "react";
/**
 * Render the column header with the weekday name (e.g. "Mo", "Tu", etc.).
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
export function Weekday(props) {
    return React.createElement("th", { ...props });
}
//# sourceMappingURL=Weekday.js.map